module.exports = __webpack_public_path__ + "img/splitFileNum1.e72d1868.svg";